const getters = {
  token: state => state.token,
  role: state => state.role,
  newrouter: state => state.newrouter,
  getPermission(state) {
    return function (navName, childName, btnName) {
      for (let i = 0; i < state.permissions.length; i++) {
        // 判断最外层的导航栏
        if (state.permissions[i].controlRouter == navName) {
          // 如果有子导航
          if (childName) {
            for (let a = 0; a < state.permissions[i].children.length; a++) {
              // 判断子导航
              if (state.permissions[i].children[a].controlRouter == childName) {
                // console.log(state.permissions[i].children[a].controlRouter);
                // 如果要判断按钮则判断，不需要则直接返还
                if (btnName) {
                  for (let b = 0; b < state.permissions[i].children[a].button.length; b++) {
                    // 判断按钮权限
                    if (state.permissions[i].children[a].button[b].controlRouter == btnName) {
                      // console.log(state.permissions[i].children[a].button[b].controlRouter);
                      return true
                    }
                  }
                } else {
                  return true
                }
              }
            }
          } else {
            // 没有子导航
            for (let a = 0; a < state.permissions[i].button.length; a++) {
              if (state.permissions[i].button[a].controlRouter == btnName) {
                return true
              }
            }
          }
        }
      }
      return false
    }
  }
};

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js